import React, { PureComponent } from 'react'
import { Alert } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { checkSession } from '../actions'
import { disableAccreditationSort, enableAccreditationSort } from '../actions/accreditation_grid_sort'
import { fetchAccreditationStatuses } from '../actions/accreditation_statuses'
import AccreditationSearchBar from '../components/accreditation_status/accreditation-search-bar'
import AccreditationStatusTable from '../components/accreditation_status/accreditation_status_table'
import { CustomPagination } from '../components/common/custom_pagination/custom_pagination'
import { DivContentBox, DivTitleBox } from '../components/common/styled'
import Spinner3Bounce from '../components/spinner_3_bounce'
import SortData from '../models/sort_data'
import { addToSearch, getActivePage, getSearchParams } from '../utils/helpers'
import { getSortDirection } from '../utils/sort'

/**
 * container for Accreditation Statuses
 */
export class AccreditationStatuses extends PureComponent {
  static recordsPerPage = 10

  state = {
    filter: {
      search: '',
      status: null,
    },
    ordering: null,
  }

  constructor(props) {
    super(props)
    const { status, search, ordering } = getSearchParams()
    const filter = this.state.filter
    this.state = {
      filter: { ...filter, ...{ status, search: search || '' } },
      ordering,
    }
  }

  componentDidMount() {
    const { checkSession, fetchAccreditationStatuses, location } = this.props
    checkSession()
    fetchAccreditationStatuses(getActivePage(location), AccreditationStatuses.recordsPerPage, this.state.filter)
  }

  handleSelectPage = (page, metaKey) => {
    if (page === getActivePage(this.props.location)) {
      return
    }
    this.search(page, undefined, metaKey)
  }

  search = (page, sortData, metaKey) => {
    const { props, state } = this
    const { navigateToPage, fetchAccreditationStatuses, navigateToPageInNewWindow } = props
    const { filter } = state
    let searchString = `?page=${page || getActivePage(props.location)}`
    const { search, status } = filter
    if (search) {
      searchString = addToSearch(searchString, `search=${search}`)
    }

    if (status && status !== 'All') {
      searchString = addToSearch(searchString, `status=${status}`)
    }

    if (sortData) {
      const { field, order } = sortData
      if (field && order) {
        searchString = addToSearch(searchString, `ordering=${order === 'asc' ? field : `-${field}`}`)
      }
    }
    if (metaKey) {
      navigateToPageInNewWindow('', searchString || '')
    } else {
      fetchAccreditationStatuses(page, AccreditationStatuses.recordsPerPage, filter, sortData)
      navigateToPage('', searchString || '')
    }
  }

  /**
   * @todo move Tri-State sequence to it's own class
   * @param field
   */
  handleTableSort = (field) => {
    const { props } = this
    const { sortField, sortOrder, enableAccreditationSort, disableAccreditationSort } = props

    const sortDirection = getSortDirection(sortOrder, sortField, field)
    if (sortDirection) {
      enableAccreditationSort(field, sortDirection)
    } else {
      disableAccreditationSort()
      field = null
    }
    this.search(getActivePage(props.location), new SortData(field, sortDirection))
  }

  updateFilter = (filter) => this.setState({ filter })

  onSearch = (filter) => this.setState({ filter }, () => this.search(1))

  reset = () => {
    const { props } = this
    const { navigateToPage, fetchAccreditationStatuses } = props
    fetchAccreditationStatuses(1, AccreditationStatuses.recordsPerPage)
    navigateToPage('', '')
  }

  render() {
    const { state, props } = this
    const { requestUrl, results, errorMessage, isAuthenticated, isFetching, navigateToIdentity, count } = props
    if (!isAuthenticated) {
      return null
    }

    if (isFetching) {
      return (
        <div className='text-center grid-spinner-mt-240'>
          <Spinner3Bounce isActive />
        </div>
      )
    }

    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <DivTitleBox className='ibox-title'>
          <div className='row'>
            <AccreditationSearchBar
              filter={state.filter}
              updateFilter={this.updateFilter}
              onSearch={this.onSearch}
              onReset={(e) => this.reset()}
              count={count}
              requestUrl={requestUrl}
            />
          </div>
        </DivTitleBox>
        <DivContentBox className='ibox-content'>
          <div>
            {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}
            <AccreditationStatusTable
              handleTableSort={this.handleTableSort}
              results={results}
              navigateToIdentity={navigateToIdentity}
            />
            <div className='text-center'>
              <CustomPagination
                activePage={getActivePage(props.location)}
                onPageChanged={this.handleSelectPage}
                totalRecords={count}
                pageLimit={AccreditationStatuses.recordsPerPage}
              />
            </div>
          </div>
        </DivContentBox>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  isAuthenticated: state.auth.isAuthenticated,
  errorMessage: state.accreditationStatuses.errorMessage,
  results: state.accreditationStatuses.results,
  isFetching: state.accreditationStatuses.isFetching,
  count: state.accreditationStatuses.count,
  nextUrl: state.accreditationStatuses.nextUrl,
  pageHash: ownProps.location.hash,
  sortField: state.accreditationGridSort.sortField,
  requestUrl: state.accreditationStatuses.requestUrl,
})

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      fetchAccreditationStatuses,
      checkSession,
      enableAccreditationSort,
      disableAccreditationSort,
      navigateToPage: (p, s) => ownProps.history.push({ pathname: '/accreditation-statuses', search: s || '' }),
      navigateToPageInNewWindow: (p, s) => {
        window.open(`/accreditation-statuses${s}`, '_blank')
      },
      navigateToIdentity: (id) => ownProps.history.push('/tx-details/' + id),
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AccreditationStatuses))
